import { render } from "./ChartA.vue?vue&type=template&id=cc54f4ee"
import script from "./ChartA.vue?vue&type=script&lang=ts"
export * from "./ChartA.vue?vue&type=script&lang=ts"
script.render = render

export default script